import { UserType } from "../../../login/loginTypes"
import { MessageAdditionalDataRecipientsType } from "./serviceCenterMessagesTypes"

// Re-export common types from merchant messages
export type {
    MessageItem,
    MessageDetails,
    CreateEditMessageFormValues,
    MessageTagValue,
} from "../../../merchant/admin/messages/messagesTypes"

export enum MessagePublishType {
    PUBLISHED = "PUBLISHED",
    UPCOMING = "UPCOMING",
    EXPIRED = "EXPIRED",
}

export type ServiceCenterMessage = Readonly<{
    id: number
    title: string
    publishTime: string
    expirationDate?: string
    editDetails?: {
        update?: {
            canUpdate: boolean
            until: string
        }
        delete?: {
            canDelete: boolean
            until: string
        }
    }
}>

export {
    MessageAdditionalDataRecipientsType,
    MessageAdditionalDataChannelsType,
} from "../../../merchant/admin/messages/messagesTypes"

export type ServiceCenterMessageAdditionalData = Readonly<{
    sender: {
        type: UserType
        serviceCenter: {
            id: number
        }
        user: {
            id: number
        }
    }
    recipients: {
        type: MessageAdditionalDataRecipientsType
        userTypes: UserType[]
    }[]
}>
